import { Irai } from "../types/GxpTypes";
import { getJapanDateString } from "./DateUtils";

/**
 * 新規作成用の空の依頼(Irai)データを生成する
 * @param userName ログインユーザーの名前（表示名）
 * @param userId ログインユーザーのID（メールアドレス）
 * @returns 初期化されたIraiオブジェクト
 */
export const createEmptyIrai = (userName: string, userId: string): Irai => {
    return {
        id: "00000000",
        statusId: 0,
        status: "入力中",
        formNo: 1,
        slideOriginNum: 0, // Optional field for slide origin number
        procCnt: 0, // Optional field for procedure count
        iraiDate: "",
        anonymousId: "",
        approvalDoctorName: userName,
        dataApprovalDoctorName: "",
        approvalDate: "",
        specimenId: null,
        patientFirstName: "",
        patientLastName: "",
        patientName: "",
        patientBirthday: "1980-01-01",
        patientGender: 2, // デフォルトで女性を設定
        organizationId: 0, // Optional field for organization ID
        organizationName: "",
        approvalDoctorId: userId,
        dataApprovalDoctorId: "",
        sampleDate: getJapanDateString(),
        lymphStsId: 1,
        esStsId: 2,
        prStsId: 2,
        her2StsId: 1,
        diagnosisId: 2,
        ki67Per: 0.0,
        tclass: 1,
        nclass: 1,
        mclass: 1,
        menstruation: 3, // 不明
        tumorGrade: 4,  // 不明
        biopsyId: 1, // 外科的生検
        submissionDate: null,
        patientId: "",
        preFailureId: "",
        failureReason: "",
    };
};
